import { TimeSeriesChartDataItem, deriveTime } from './TimeSeriesChartData';
import {
    AnySelection,
    seriesSvgArea,
    seriesSvgLine,
    seriesSvgMulti,
} from '@d3fc/d3fc-series';
import { curveStepAfter } from 'd3-shape';
import { ScaleLinear } from 'd3-scale';

export const area = <T extends TimeSeriesChartDataItem>(
    mainValue: (d: T) => number | undefined,
    className: string,
    crossValue: (d: T) => number | undefined = deriveTime,
    baseValue: (d: T) => number | undefined = () => 0
) =>
    seriesSvgArea()
        .crossValue(crossValue)
        .mainValue(mainValue)
        .baseValue(baseValue)
        .curve(curveStepAfter)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .decorate((selection: any) => {
            selection.classed(className, true);
        });

export const generateAreaSeries = <T extends TimeSeriesChartDataItem>(
    selectFn: (d: T) => number,
    scaleFn: ScaleLinear<number, number>,
    fillGradientId: string,
    areaClass: string
) => {
    const getTime = (d: T) => d.time;
    const mainValueFn = (d: T) => scaleFn(selectFn(d));

    const area = seriesSvgArea()
        .crossValue(getTime)
        .mainValue(mainValueFn)
        .decorate((selection: AnySelection) => {
            selection.classed(areaClass, true);
            selection.attr('fill', `url(#${fillGradientId})`);
        });

    const areaLine = seriesSvgLine()
        .crossValue(getTime)
        .mainValue(mainValueFn)
        .decorate((selection: AnySelection) => {
            selection.classed(areaClass, true);
        });

    return seriesSvgMulti().series([area, areaLine]);
};
